// 测试环境
// export const baseUrl = 'http://192.168.31.5:8082'
// export const resourceUrl = 'http://106.52.94.28:8888'
// export const uploadUrl = 'http://106.52.94.28:8888/file/upload'

// 测试环境（本地后端）
// export const baseUrl = 'http://localhost:8082'
// export const resourceUrl = 'https://resources.xbov.cn'
// export const uploadUrl = 'https://resources-api.xbov.cn/file/upload'

// 线上环境
export const baseUrl = 'https://monitor-api.xbov.cn'
export const resourceUrl = 'https://resources.xbov.cn'
export const uploadUrl = 'https://resources-api.xbov.cn/file/upload'



